export default __webpack_public_path__ + "static/media/035-male body.5e41be6b.svg";